module.exports = __webpack_public_path__ + "static/media/demo-store-1.e0c0ebc5.jpg";